import script from "./star-rating-input.vue?vue&type=script&setup=true&lang=ts"
export * from "./star-rating-input.vue?vue&type=script&setup=true&lang=ts"

import "./star-rating-input.vue?vue&type=style&index=0&id=7044c10c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7044c10c"]])

export default __exports__